module.exports = __webpack_public_path__ + "img/paid.fdb5fd88.svg";